import { ReactComponent as IconCalendar } from '@ubeya/shared-web/assets/help-desk/icon-calendar.svg';
import { ReactComponent as IconTarget } from '@ubeya/shared-web/assets/help-desk/icon-target.svg';
import { ReactComponent as IconWallet } from '@ubeya/shared-web/assets/help-desk/icon-wallet.svg';
import { ReactComponent as IconPerson } from '@ubeya/shared-web/assets/help-desk/icon-person.svg';
import { ReactComponent as IconHelp } from '@ubeya/shared-web/assets/help-desk/icon-help.svg';
import { ReactComponent as IconShield } from '@ubeya/shared-web/assets/help-desk/icon-shield.svg';
import { ReactComponent as IconLightning } from '@ubeya/shared-web/assets/help-desk/icon-lightning.svg';
import { ReactComponent as IconDocument } from '@ubeya/shared-web/assets/help-desk/icon-document.svg';

export const HELP_DESK_CATEGORY_NAME_MAX_LENGTH = 35;
export const HELP_DESK_CATEGORY_SHORTCUT_MAX_LENGTH = 5;
export const HELP_DESK_CATEGORY_DESCRIPTION_MAX_LENGTH = 150;

/**
 * Help Desk category colors (fixed palette).
 * Use these hex values when creating/editing categories.
 */
export const HELP_DESK_CATEGORY_COLORS = [
  { value: '#006AFF', label: 'Blue' },
  { value: '#FF3F97', label: 'Pink' },
  { value: '#FF8833', label: 'Orange' },
  { value: '#4447B9', label: 'Indigo' },
  { value: '#9E30E1', label: 'Purple' },
  { value: '#14AFB4', label: 'Teal' },
  { value: '#00B341', label: 'Green' },
  { value: '#E53935', label: 'Red' }
];

/** Default color when none is set (e.g. during creation). Icons use this so they are always visible. */
export const HELP_DESK_DEFAULT_CATEGORY_COLOR = HELP_DESK_CATEGORY_COLORS[0].value;

/**
 * Help Desk category icons (8 options).
 * Value matches the SVG filename without extension under shared-web/assets/help-desk/.
 */
export const HELP_DESK_CATEGORY_ICONS = [
  { value: 'icon-calendar', label: 'Calendar' },
  { value: 'icon-target', label: 'Target' },
  { value: 'icon-wallet', label: 'Wallet' },
  { value: 'icon-person', label: 'Person' },
  { value: 'icon-help', label: 'Help' },
  { value: 'icon-shield', label: 'Shield' },
  { value: 'icon-lightning', label: 'Lightning' },
  { value: 'icon-document', label: 'Document' }
];

export const HELP_DESK_ICON_MAP = {
  'icon-calendar': IconCalendar,
  'icon-target': IconTarget,
  'icon-wallet': IconWallet,
  'icon-person': IconPerson,
  'icon-help': IconHelp,
  'icon-shield': IconShield,
  'icon-lightning': IconLightning,
  'icon-document': IconDocument
};
